import { HTMLMotionProps } from 'motion/react'

// * Fade In

export const fadeIn: HTMLMotionProps<'div'> = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { ease: 'easeInOut', duration: 0.3 },
}

export const fadeInUp: HTMLMotionProps<'div'> = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 20 },
    transition: { ease: 'easeInOut', duration: 0.3 },
}

export const fadeInDown: HTMLMotionProps<'div'> = {
    initial: { opacity: 0, y: -20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
    transition: { ease: 'easeInOut', duration: 0.3 },
}

export const fadeInLeft: HTMLMotionProps<'div'> = {
    initial: { opacity: 0, x: -20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -20 },
    transition: { ease: 'easeInOut', duration: 0.3 },
}

export const fadeInRight: HTMLMotionProps<'div'> = {
    initial: { opacity: 0, x: 20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 20 },
    transition: { ease: 'easeInOut', duration: 0.3 },
}

// * Blur In

export const blurIn: HTMLMotionProps<'div'> = {
    initial: { opacity: 0, filter: 'blur(10px)' },
    animate: { opacity: 1, filter: 'blur(0px)' },
    exit: { opacity: 0, filter: 'blur(10px)' },
    transition: { ease: 'easeInOut', duration: 0.3 },
}

export const blurInUp: HTMLMotionProps<'div'> = {
    initial: { opacity: 0, filter: 'blur(10px)', y: 20 },
    animate: { opacity: 1, filter: 'blur(0px)', y: 0 },
    exit: { opacity: 0, filter: 'blur(10px)', y: 20 },
    transition: { ease: 'easeInOut', duration: 0.3 },
}

export const blurInDown: HTMLMotionProps<'div'> = {
    initial: { opacity: 0, filter: 'blur(10px)', y: -20 },
    animate: { opacity: 1, filter: 'blur(0px)', y: 0 },
    exit: { opacity: 0, filter: 'blur(10px)', y: -20 },
    transition: { ease: 'easeInOut', duration: 0.3 },
}

export const blurInLeft: HTMLMotionProps<'div'> = {
    initial: { opacity: 0, filter: 'blur(10px)', x: -20 },
    animate: { opacity: 1, filter: 'blur(0px)', x: 0 },
    exit: { opacity: 0, filter: 'blur(10px)', x: -20 },
    transition: { ease: 'easeInOut', duration: 0.3 },
}

export const blurInRight: HTMLMotionProps<'div'> = {
    initial: { opacity: 0, filter: 'blur(10px)', x: 20 },
    animate: { opacity: 1, filter: 'blur(0px)', x: 0 },
    exit: { opacity: 0, filter: 'blur(10px)', x: 20 },
    transition: { ease: 'easeInOut', duration: 0.3 },
}
